module.exports = __webpack_public_path__ + "img/seriesbg.21929e3e.jpg";